import { render, staticRenderFns } from "./StepIOSExtendedVisualNotification.vue?vue&type=template&id=0e7ac6a0&scoped=true&"
import script from "./StepIOSExtendedVisualNotification.vue?vue&type=script&lang=js&"
export * from "./StepIOSExtendedVisualNotification.vue?vue&type=script&lang=js&"
import style0 from "./StepIOSExtendedVisualNotification.vue?vue&type=style&index=0&id=0e7ac6a0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ac6a0",
  null
  
)

export default component.exports